/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ESuiviAction {
    Realisee = 'Realisee',
    ARealiser = 'ARealiser',
    Aucune = 'Aucune'
}


export function ESuiviActionFromJSON(json: any): ESuiviAction {
    return ESuiviActionFromJSONTyped(json, false);
}

export function ESuiviActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ESuiviAction {
    return json as ESuiviAction;
}

export function ESuiviActionToJSON(value?: ESuiviAction | null): any {
    return value as any;
}

